export default __webpack_public_path__ + "static/media/p-logo-r.0ad69d7e.svg";